// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lc_E","content":"styles_content__1gidY","row":"styles_row__1fCHQ","footer":"styles_footer__JcrKw","phraseLength":"styles_phraseLength__2gKIh"};